import React from "react";
import { Routes, Route } from "react-router-dom";
import LandingPage from "../pages/LandingPage";
import EventDetails from "../components/events/EventDetails";
import CheckoutForm from "../components/forms/CheckoutForm";
import About from "../pages/About";
import InvoicePDF from "../components/card/InvoicePDF";
import ContactUs from "../pages/ContactUs";
import BookingPage from "../pages/BookingPage";

const MainRoutes = () => {
  return (
    <Routes>
      <Route path="/" element={<LandingPage />} />;
      <Route path="/event-details/:eventId" element={<EventDetails />} />;
      <Route path="/booking/:eventId" element={<BookingPage />} />;
      <Route
        path="/event-details/:eventId/checkout/:bookingId"
        element={<CheckoutForm />}
      />
      <Route path="/invoice-pdf/:paymentId" element={<InvoicePDF />} />;
      <Route path="/contact-us" element={<ContactUs />} />;
      <Route path="/about-us" element={<About />} />;
    </Routes>
  );
};

export default MainRoutes;
